<script>
export default {
  name: "hitchRide",
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/airport/config/commission",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [],
      },
      // 表头
      columns: [
        { prop: "organizationName", label: "机构名称" },
        { prop: "status", label: "平台抽成" },
        { prop: "serviceFee", label: "信息费" },
        { prop: "rakeTime", label: "抽成时间" },
      ],
      dialogVisible: false,
      form: {},
      rules: {
        serviceFee: [
          { required: true, message: "请输入信息费", trigger: "blur" },
        ]
      },
    };
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
  },
  async created() {
    await this.mixinOrganizations();
  },
  methods: {
    showDialog(row)  {
      this.form = {...row};
      this.dialogVisible = true;
    },
    handleClose() {
      this.form = {};
      this.dialogVisible = false;
      this.$refs.customTable.listFn();
    },
    async postFn(){
      let url = "/api/v1/manage/airport/config/commission";
      let params = {
        serviceFee: this.form.serviceFee,
        organizationId: this.form.organizationId
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = await this.$axios.post(url, params);
          if (data && data.code === 1) {
            this.$message.success("修改成功！");
            this.handleClose();
          }
        } else {
          return false;
        }
      });
    }
  },
};
</script>
<template>
  <div class="hitchRide">
    <div class="blueInfo">
      <p>
        * 提现规则按照机构配置，可配置该机构司机余额提现日期、时间、次数及金额大小。
      </p>
    </div>
    <custom-table
      :has-organization="false"
      ref="customTable"
      :customOptions="customOptions"
      :columns="columns"
      :refreshShow="false"
      labelWidth="135"
      style="height: calc(100vh - 210px)"
    >
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'status'">
          <span>调度员分配</span>
        </template>
        <template v-else-if="item.prop === 'serviceFee'">
          <span :style="{color: row.serviceFee ? '#666' : '#aaa'}">{{ row.serviceFee ? row.serviceFee : "暂未配置" }}</span>
        </template>
        <template v-else-if="item.prop === 'rakeTime'">
          <span>订单完成</span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
      <template slot="table-operation">
        <el-table-column label="操作" width="140px" fixed="right">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="showDialog(row)">编辑</el-button>
          </div>
        </el-table-column>
      </template>
    </custom-table>
    
    <el-dialog title="抽成配置"
  :visible.sync="dialogVisible"
  width="40%"
  :before-close="handleClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="机构名称" prop="organizationId">
          <el-select
            clearable
            v-model="form.organizationId"
            placeholder="请选择机构名称"
            :disabled="true"
          >
            <el-option v-for="item in organizations" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台抽成" prop="name">
          <span>由调度员现场现场确认并分配</span>
        </el-form-item>
        <el-form-item label="信息费" prop="serviceFee">
          <el-input v-model="form.serviceFee"  v-input-filter="{min: 0.1, max: 10, precision: 2}" maxlength="6" placeholder="请输入信息费">
            <span slot="append">元</span>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="postFn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<style scoped lang="less">

</style>